<template>
  <div class="licevoischet__page">
    <div class="container-md">
      <h4 class="mt-4 modal_title">{{$t("Текущее состояние")}}
        <span class="close_btn" v-on:click="$emit('enlarge-text')"></span>
      </h4>
      <div class="row transfert">
        <div class="col-md-3">
          <p>{{$t("Резерв")}}:</p>
          <p>{{ transfertInfo.reserve | localInt }} {{$t("баллов")}} </p>
        </div>
        <div class="col-md-3">
          <p>{{$t("Трансферт из НС")}}:</p>
          <p>{{ transfertInfo.transfer_only | localInt }} {{$t("баллов")}}</p>
        </div>
        <div class="col-md-3">
          <p>{{$t("Внешний трансферт")}}:</p>
          <p>{{ transfertInfo.external_lo | localInt }} {{$t("баллов")}}</p>
        </div>
        <div class="col-md-3">
          <p>{{$t("Итоговый трансферт")}}:</p>
          <p>{{ transfertInfo.lo | localInt }} {{$t("баллов")}}</p>
        </div>
      </div>
      <h3 class="perevod">
        {{$t("Перевод количества баллов")}}
      </h3>
      <!-- <div class="row mt-3">
        <div class="col-md-6 perioad__picker">
        <BasePeriodPicker :currentPeriod="currentPeriod"
        v-on:next-period="nextPeriod" class="period_picker"/>
        </div>
      </div> -->
      <b-row align-v="end" class="row edit">
        <div class="col-xl mt-4 custom_input">
              <input type="text" name="sum" id="sum"
              required step="0.1"
              v-model="sum"
              v-currency="{

                currency: null,
                valueAsInteger: false,
                distractionFree: false,
                allowNegative: false
              }"
              @keydown="checkInput($event)"
               />
              <label for="sum">
                {{$t("Сумма")}}
              </label>
              <span class="clear_icon" @click="clearSum()"></span>
        </div>
        <div class="col custom_input">
          <input type="text" name="comm" id="comm" v-model="comm" required/>
          <label for="comm">
            {{$t("Комментарий")}}
          </label>
          <span class="clear_icon" @click="clearComm()"></span>
        </div>
        <div class="col-xl trans_btns" v-if="this.isTransfertAllowed">
          <button @click="lo2reserve"
          :disabled="isDisabled"
          :class="isDisabled ? 'disabled' : ''">
          {{$t("Перевести в резерв")}}
          </button>
          <button @click="reserve2lo"
          :disabled="isDisabled"
          :class="isDisabled ? 'disabled' : ''"
          >
          {{$t("Перевести в трансферт")}}
          </button>
        </div>
        <div class="col-xl trans_btns" v-else>
          <button @click="showError"
          :class="'disabled'">
          {{$t("Перевести в резерв")}}
          </button>
          <button @click="showError"
          :class="'disabled'"
          >
          {{$t("Перевести в трансферт")}}
          </button>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>

import $ from 'jquery';
import backApi from '../assets/backApi';
// import BasePeriodPicker from './BasePeriodPicker.vue';

export default {
  name: 'Transfert',
  // components: {
  //   BasePeriodPicker,
  // },
  props: ['id', 'parent_stock_id', 'upPeriod', 'context'],
  data() {
    return {
      transfertInfo: {},
      periods: [],
      periodIndex: 0,
      comm: null,
      sum: '',
      another_agent_id: null,
      isTransfertAllowed: false,
      months: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ],
    };
  },
  computed: {
    isDisabled() {
      if (!this.isTransfertAllowed || (this.sum === null || this.sum === '')) {
        return true;
      }
      return false;
    },
    currentPeriod() {
      try {
        return this.periods[this.periodIndex].period;
      } catch (e) {
        return '';
      }
    },
  },
  async mounted() {
    // await backApi.get('/agent/get-open-periods').then((Response) => {
    //   this.periods = Response.data.entries.sort((a, b) => {
    //     const result = a.period > b.period ? 1 : -1;
    //     return result;
    //   });
    //   this.periodIndex = this.upPeriod;
    // });
    await backApi.get('/agent/profile/child', { params: { comdte: this.upPeriod, another_agent_id: this.id } }).then(Response => {
      this.isTransfertAllowed = Response.data.transfert_permission;
    });
    await backApi.get('/agent/transfer-info', { params: { another_agent_id: this.id, comdte: this.upPeriod } }).then(response => {
      this.transfertInfo = response.data;
    });
  },
  methods: {
    showError() {
      this.showToast('Трансферт', `Трансферт за ${this.months[new Date(this.upPeriod).getMonth()]}
      ${new Date(this.upPeriod).getFullYear()} отправлен в расчет. Изменения невозможны`, 'danger');
    },
    showError2() {
      this.showToast('Трансферт', 'Итоговое значение ЛО не может быть меньше Внешнего ЛО, т.к. трансферт не может быть отрицательным', 'danger');
    },
    // eslint-disable-next-line consistent-return
    checkInput(e) {
      // console.log(e.which);
      if (e.which === 189 || e.which === 109 || e.which === 107
      || e.which === 187 || e.which === 190) {
        // eslint-disable-next-line no-restricted-globals
        e.preventDefault();
        return false;
      }
    },
    clearSum() {
      this.sum = null;
    },
    clearComm() {
      this.comm = '';
    },
    back() {
      const navEl = document.getElementsByClassName('router-link-exact-active router-link-active');
      $(navEl[0])
        .parent()
        .parent()
        .siblings()
        .addClass('active');
    },
    makeToast(append = false) {
      // eslint-disable-next-line no-plusplus
      this.toastCount++;
      this.$bvToast.toast(`This is toast number ${this.toastCount}`, {
        title: 'BootstrapVue Toast',
        autoHideDelay: 5000,
        appendToast: append,
      });
    },
    async lo2reserve() {
      if ((this.transfertInfo.lo - Number(this.sum.replace(/,/, '.').replace(/\s/g, ''))) < this.transfertInfo.external_lo) {
        this.showError2();
        return;
      }
      if (this.sum !== null && this.sum !== '') {
        await backApi
          .post(`agent/transfert/${this.id}`, {
            sum: this.sum.replace(/,/, '.').replace(/\s/g, ''),
            direction: 'lo2reserve',
            comdte: this.upPeriod,
            context: this.context,
            comm: this.comm,
          })
          .then(async () => {
            await this.createMessageBoxError(this.$t('Операция выполнена успешно'));
            backApi.get('/agent/transfer-info', { params: { another_agent_id: this.id } }).then(Response => {
              this.transfertInfo = Response.data;
            });
            this.$emit('action');
          })
          .catch(error => {
            this.createMessageBoxError(this.$t(error.response.data.detail));
          });
      }
    },
    async reserve2lo() {
      if ((this.transfertInfo.lo + Number(this.sum.replace(/,/, '.').replace(/\s/g, ''))) < this.transfertInfo.external_lo) {
        this.showError2();
        return;
      }
      if (this.sum !== null && this.sum !== '') {
        await backApi
          .post(`agent/transfert/${this.id}`, {
            sum: this.sum.replace(/,/, '.').replace(/\s/g, ''),
            direction: 'reserve2lo',
            comdte: this.upPeriod,
            context: this.context,
            comm: this.comm,
          })
          .then(async () => {
            await this.createMessageBoxError(this.$t('Операция выполнена успешно'));
            backApi.get('/agent/transfer-info', { params: { another_agent_id: this.id } }).then(Response => {
              this.transfertInfo = Response.data;
            });
            this.$emit('action');
          })
          .catch(error => {
            this.createMessageBoxError(this.$t(error.response.data.detail));
          });
      }
    },
    createMessageBoxError(messageText) {
      const h = this.$createElement;
      // More complex structure
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('h5', { class: ['text-center'] }, [messageText]),
      ]);
      // We must pass the generated VNodes as arrays
      return this.$bvModal.msgBoxOk([messageVNode], {
        buttonSize: 'xl',
        centered: true,
        cancelTitle: 'Нет',
        okTitle: 'OK',
        size: 'md',
      });
    },
    showToast(title, message, status) {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;
      // Increment the toast count
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        h('strong', { class: 'mr-2' }, message),
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h('strong', { class: 'mr-2' }, title),
        ],
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: status,
      });
    },
    nextPeriod(x) {
      this.period_enabled = true;
      this.periodIndex = (this.periodIndex + this.periods.length + x) % this.periods.length;
    },
  },
  watch: {
    currentPeriod() {
      backApi.get('/agent/profile/child', { params: { comdte: this.upPeriod, another_agent_id: this.id } }).then(Response => {
        this.isTransfertAllowed = Response.data.transfert_permission;
      });
      backApi.get('/agent/transfer-info', { params: { another_agent_id: this.id, comdte: this.upPeriod } }).then(response => {
        this.transfertInfo = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.transfert {
  margin-bottom: 30px;
  margin-top: 30px;
  & p {
    padding: 0;
    margin: 0;
  }
  & > .col-md-6 {
    p:nth-of-type(1) {
      color: #9a9a9a;
    }
    p:nth-of-type(2) {
      font-weight: 500;
    }
  }
}
.edit {
  & button {
    width: 48%;
    padding: 8px 0px;
    background: white;
    color: #32aaa7;
    border: 1px solid #32aaa7;
    border-radius: 2px;
    font-weight: 500;
  }
}
.trans_btns {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  & button.disabled{
    color: #9A9A9A;
    border-color: #C4C4C4;
    cursor: pointer;
  }
}
@media (max-width: 1050px) {
  .trans_btns {
    margin-top: 20px;
  }
}
@media (max-width: 768px) {
  .perevod {
    font-size: 20px;
    // text-transform: uppercase;
    margin-bottom: 0;
  }
}
@media (max-width: 425px) {
  .perevod {
    font-size: 16px;
    // text-transform: uppercase;
    margin-bottom: 0;
  }
  .trans_btns {
    flex-direction: column;
    button {
      width: 100%;
      margin-bottom: 20px;
      font-size: 16px;
    }
  }
  .transfert {
      & p {
        font-size: 14px;
      }
      & > .col-md-6 {
        p:nth-of-type(1) {
        }
        p:nth-of-type(2) {
        }
      }
  }
}
</style>
